import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import LangForm from "./_form";
import LangList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { clearState, setApp, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";

function Lang(props) {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const createItem = () => {
        props.setForm();
        ModalFormContainer( LangForm, { generalPropouse : false } )
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <LangList generalPropouse={false} />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setForm,
    setApp,
    setViewMode,
    clearListState,
});

export default connect(mapStateToProps, mapActionsToProps)(Lang)

